import axios from "axios";
//import {browserHistory} from "react-router";

// const
const REDIRECT_TO_ALGORITHM_EDIT = "algorithmEdit/REDIRECT_TO_ALGORITHM_EDIT";
const ALGORITHM_EDIT_UPDATE_DATA = "algorithmEdit/ALGORITHM_EDIT_UPDATE_DATA";
const ALGORITHM_EDIT_STORE_ALGORITHM = "algorithmEdit/ALGORITHM_EDIT_STORE_ALGORITHM";
const ALGORITHM_EDIT_STORE_ALGORITHM_CATEGORIES = "algorithmEdit/ALGORITHM_EDIT_STORE_ALGORITHM_CATEGORIES";
const ALGORITHM_EDIT_STORE_ALGORITHM_TYPES = "algorithmEdit/ALGORITHM_EDIT_STORE_ALGORITHM_TYPES";
const ALGORITHM_EDIT_TOGGLE_MODAL = "algorithmEdit/ALGORITHM_EDIT_TOGGLE_MODAL";
const ALGORITHM_EDIT_TOGGLE_LOADING = "algorithmEdit/ALGORITHM_EDIT_TOGGLE_LOADING";
const ALGORITHM_EDIT_TOGGLE_UPLOADING = "algorithmEdit/ALGORITHM_EDIT_TOGGLE_UPLOADING";

const ALGORITHM_EDIT_MODAL_SUCCESS_TITLE = "scenes_Algorithm_AlgorithmEdit_modal_success_title";
const ALGORITHM_EDIT_MODAL_FAIL_TITLE = "scenes_Algorithm_AlgorithmEdit_modal_fail_title";
const ALGORITHM_EDIT_MODAL_OK_LABEL = "scenes_Algorithm_AlgorithmEdit_modal_OK_label";
const ALGORITHM_EDIT_MODAL_CANCEL_LABEL = "scenes_Algorithm_AlgorithmEdit_modal_cancel_label";
const ALGORITHM_EDIT_MODAL_YES_LABEL = "scenes_Algorithm_AlgorithmEdit_modal_yes_label";
const ALGORITHM_EDIT_MODAL_NO_LABEL = "scenes_Algorithm_AlgorithmEdit_modal_no_label";
const ALGORITHM_EDIT_MODAL_RETURN_LABEL = "scenes_Algorithm_AlgorithmEdit_modal_return_label";

const ALGORITHM_EDIT_MODAL_SUBMIT_SUCCESS_CONTENT = "scenes_Algorithm_AlgorithmEdit_modal_submitSuccess_content";
const ALGORITHM_EDIT_MODAL_SUBMIT_FAIL_CONTENT = "scenes_Algorithm_AlgorithmEdit_modal_submitFail_content";
const ALGORITHM_EDIT_MODAL_AUDIT_SUCCESS_CONTENT = "scenes_Algorithm_AlgorithmEdit_modal_auditSuccess_content";
const ALGORITHM_EDIT_MODAL_AUDIT_FAIL_CONTENT = "scenes_Algorithm_AlgorithmEdit_modal_auditFail_content";

// reducer
export const algorithmEdit = (state = {
  loading: false,
  uploading: false,
  rowKey: 0,

  modalVisible: false,
  modalTitle: "",
  modalContent: "",
  modalOk: "",
  modalCancel: "",
  onOk: null,
  onCancel: null,

  algorithmId: "",
  algorithmCategories: [],
  algorithmTypes: [],
  description: "",
  name: "",
  algorithmCategory: "",
  algorithmType: "",
  algorithmParameters: [],
  algorithmFile: [],
  algorithmFileId: "",
}, action) => {
  switch (action.type) {
    case REDIRECT_TO_ALGORITHM_EDIT:
      return {
        ...state,
        algorithmId: action.data
      };
    case ALGORITHM_EDIT_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case ALGORITHM_EDIT_STORE_ALGORITHM:
      return {
        ...state,
        loading: false,
        uploading: false,
        modalVisible: false,
        rowKey: 0,
        algorithmId: action.data.id,
        name: action.data.name,
        description: action.data.description,
        algorithmCategory: action.data.algorithmCategory.id,
        algorithmType: action.data.algorithmType.code,
        algorithmParameters: action.data.parameters.map(parameter => {
          parameter.key = parameter.id;
          return parameter;
        })
      };
    case ALGORITHM_EDIT_STORE_ALGORITHM_CATEGORIES:
      return {
        ...state,
        algorithmCategories: action.data
      };
    case ALGORITHM_EDIT_STORE_ALGORITHM_TYPES:
      return {
        ...state,
        algorithmTypes: action.data
      };
    case ALGORITHM_EDIT_TOGGLE_MODAL:
      return {
        ...state,
        modalVisible: action.data.modalVisible,
        modalTitle: action.data.modalTitle,
        modalContent: action.data.modalContent,
        modalOk: action.data.modalOk,
        modalCancel: action.data.modalCancel,
        onOk: action.data.onOk,
        onCancel: action.data.onCancel
      };
    case ALGORITHM_EDIT_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    case ALGORITHM_EDIT_TOGGLE_UPLOADING:
      return {
        ...state,
        uploading: action.data
      };
    default:
      return state
  }
};

/**
 * 前页跳转此页，需要传递参数：algorithm.id
 */
export function redirectToAlgorithmEditPage(algorithmId) {
  return {
    type: REDIRECT_TO_ALGORITHM_EDIT,
    data: algorithmId
  };
}

/**
 * update data based
 */
export const updateAlgorithmEditData = (data) => {
  return {
    type: ALGORITHM_EDIT_UPDATE_DATA,
    data: data
  }
};

/**
 * check and init algorithm
 */
export const initAlgorithm = (data) => (dispatch) => {

  let algorithmId = data.algorithmId;
  if (algorithmId !== null && algorithmId !== undefined && algorithmId !== "") {
    dispatch(toggleLoading(true));
    axios.get(`/api-algorithm/algorithms/search/id?id=${algorithmId}`, {contentType: "application/json"}).then(
      response => {
        if (response.data._embedded.algorithms.length > 0) {
          dispatch(storeAlgorithm(response.data._embedded.algorithms[0]));
          dispatch(toggleLoading(false));
        } else {
          this.props.history.push("/exception/415");
        }
      }
    );
  } else {
    this.props.history.push("/exception/415");
  }
};

/**
 * store algorithm
 */
export const storeAlgorithm = (algorithm) => {
  return {
    type: ALGORITHM_EDIT_STORE_ALGORITHM,
    data: algorithm
  }
};

/**
 * get all algorithm categories
 */
export const getAlgorithmCategories = () => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get("/api-algorithm/getAlgorithmCategoryTree", {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeAlgorithmCategories(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all algorithm categories
 */
export const storeAlgorithmCategories = (algorithmCategories) => {
  return {
    type: ALGORITHM_EDIT_STORE_ALGORITHM_CATEGORIES,
    data: algorithmCategories
  }
};

/**
 * get all algorithm types
 */
export const getAlgorithmTypes = () => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get("/api-algorithm/algorithmTypes", {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeAlgorithmTypes(response.data._embedded.algorithmTypes));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all algorithm types
 */
export const storeAlgorithmTypes = (algorithmTypes) => {
  return {
    type: ALGORITHM_EDIT_STORE_ALGORITHM_TYPES,
    data: algorithmTypes
  }
};

/**
 * submit data
 */
export const updateAlgorithm = (data) => (dispatch) => {
  console.log("data",data);
  dispatch(toggleLoading(true));
  axios({
    method: "PUT",
    url: "/api-algorithm/updateAlgorithm",
    contentType: "application/json",
    withCredentials: true,
    data: {
      "id": data.algorithmId,
      "name": data.name,
      "description": data.description,
      "algorithmCategory": {"id": data.algorithmCategory},
      "algorithmType": {"code": data.algorithmType},
      "algorithmFileId": data.algorithmFileId,
      "parameters": data.parameters,
      "updateById": data.updateById,
      "updateByName": data.updateByName,
      "enabled": true
    },
  }).then(
    response => {
      dispatch(toggleLoading(false));
      if (response.status === 200) {
        console.info("success update algorithm");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: ALGORITHM_EDIT_MODAL_SUCCESS_TITLE,
          modalContent: ALGORITHM_EDIT_MODAL_SUBMIT_SUCCESS_CONTENT,
          modalOk: ALGORITHM_EDIT_MODAL_YES_LABEL,
          modalCancel: ALGORITHM_EDIT_MODAL_NO_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }));
            dispatch(updateAlgorithmStatus({
              algorithmId: data.algorithmId,
              algorithmStatus: "2"
            }));
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }));
            //返回！
            this.props.history.push("/console/algorithm-list");
          }
        }));
      } else {
        console.error("fail to update algorithm");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: ALGORITHM_EDIT_MODAL_FAIL_TITLE,
          modalContent: ALGORITHM_EDIT_MODAL_SUBMIT_FAIL_CONTENT,
          modalOk: ALGORITHM_EDIT_MODAL_OK_LABEL,
          modalCancel: ALGORITHM_EDIT_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
      }
    }
  ).catch(
    err => {
      console.error("fail to update algorithm:", err);
      dispatch(toggleLoading(false));
      dispatch(toggleModal({
        modalVisible: true,
        modalTitle: ALGORITHM_EDIT_MODAL_FAIL_TITLE,
        modalContent: ALGORITHM_EDIT_MODAL_SUBMIT_FAIL_CONTENT,
        modalOk: ALGORITHM_EDIT_MODAL_OK_LABEL,
        modalCancel: ALGORITHM_EDIT_MODAL_CANCEL_LABEL,
        onOk: () => {
          dispatch(toggleModal({
            modalVisible: false
          }))
        },
        onCancel: () => {
          dispatch(toggleModal({
            modalVisible: false
          }))
        }
      }));
    }
  );
};

/**
 * update Algorithm Status
 */
export const updateAlgorithmStatus = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios({
    method: "PUT",
    url: "/api-algorithm/updateAlgorithmStatus",
    contentType: "application/json",
    withCredentials: true,
    data: {
      "id": data.algorithmId,
      "algorithmStatus": {"code": data.algorithmStatus},
    },
  }).then(
    response => {
      dispatch(toggleLoading(false));
      if (response.status === 200) {
        console.info("success to update algorithm status");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: ALGORITHM_EDIT_MODAL_SUCCESS_TITLE,
          modalContent: ALGORITHM_EDIT_MODAL_AUDIT_SUCCESS_CONTENT,
          modalOk: ALGORITHM_EDIT_MODAL_OK_LABEL,
          modalCancel: ALGORITHM_EDIT_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }));
            //返回！
            this.props.history.push("/console/algorithm-list")
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }));
            //返回！
            this.props.history.push("/console/algorithm-list")
          }
        }));
      } else {
        console.error("fail to update algorithm status");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: ALGORITHM_EDIT_MODAL_FAIL_TITLE,
          modalContent: ALGORITHM_EDIT_MODAL_AUDIT_FAIL_CONTENT,
          modalOk: ALGORITHM_EDIT_MODAL_OK_LABEL,
          modalCancel: ALGORITHM_EDIT_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
      }
    }
  ).catch(
    err => {
      console.error("fail to update algorithm status:", err);
      dispatch(toggleLoading(false));
      dispatch(toggleModal({
        modalVisible: true,
        modalTitle: ALGORITHM_EDIT_MODAL_FAIL_TITLE,
        modalContent: ALGORITHM_EDIT_MODAL_AUDIT_FAIL_CONTENT,
        modalOk: ALGORITHM_EDIT_MODAL_OK_LABEL,
        modalCancel: ALGORITHM_EDIT_MODAL_CANCEL_LABEL,
        onOk: () => {
          dispatch(toggleModal({
            modalVisible: false
          }))
        },
        onCancel: () => {
          dispatch(toggleModal({
            modalVisible: false
          }))
        }
      }));
    }
  );
};

/**
 * toggle modal
 */
export const toggleModal = (show) => {
  return {
    type: ALGORITHM_EDIT_TOGGLE_MODAL,
    data: show
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: ALGORITHM_EDIT_TOGGLE_LOADING,
    data: show
  }
};

/**
 * toggle uploading
 */
export const toggleUploading = (show) => {
  return {
    type: ALGORITHM_EDIT_TOGGLE_UPLOADING,
    data: show
  }
};
